import {
	IonicPage,
	LoadingController,
	NavController,
	NavParams,
	ToastController
} from 'ionic-angular'

import { AuthProvider } from '../../providers/auth/auth'
import { Component } from '@angular/core'
import { CondominiumProvider } from '../../providers/condominium/condominium'
import { Condominium } from '../../models/models'
import { ControlPanelPage } from '../control-panel/control-panel'
@IonicPage()
@Component({
	selector: 'page-condominium-write',
	templateUrl: 'condominium-write.html',
})
export class CondominiumWritePage {
	public condominium: Condominium

	private loading: any

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		public condominiums: CondominiumProvider,
		public loadingCtrl: LoadingController,
		public auth: AuthProvider,
		public toastCtrl: ToastController
	) {
		this.condominium = navParams.get('condominium')

		/*se non ha il condominio impostato è una create, segnaposto vuoto*/
		if(!this.condominium) {
			this.condominium = <Condominium>{
				address: {
					formatted: '',
					type: 'location',
					postal_code: '',
					route: '',
					street_number: '',
				},
				name: '',
				fiscal_code: '',
				settlement: '',
				timetable: ''
			}
		}
	}

	public goToControlPanel() {
		this.navCtrl.setRoot(ControlPanelPage)
	}
	public undo() {
		this.navCtrl.pop()
	}

	public save() {
		this.loading = this.loadingCtrl.create({
			content: 'Salvataggio in corso...',
			dismissOnPageChange: false
		})
		this.loading.present()
		this.condominiums.save(this.condominium).then(
			(condominium: any) => {
				this.loading.dismiss()
				console.log("Condominio creato: ", condominium)
				let toast = this.toastCtrl.create({
					message: 'Condominio "' + this.condominium.name + '" salvato',
					position: 'middle',
					duration: 3000
				})
				toast.present()
				this.navCtrl.pop()
			}).catch((error: any) => {
				this.loading.dismiss()
				console.error("Errore creando il condominio:", error)
			}
			)
	}
}



// WEBPACK FOOTER //
// ./src/pages/condominium-write/condominium-write.ts